'use strict';

const Constants = require('../constants');

const DatePickerPresenter = require('../presenters/datepicker');

const CalendarView = require('./calendar');

const DatesView = require('./dates');

const PickerListView = require('./pickerlist');

class DatePickerView extends PickerListView {
  attributes() {
    return { 'data-bhw': 'GliveBookingDealBookerDates' };
  }

  constructor() {
    super(...arguments);
    this.collection.on('reset', this.render, this);
  }

  initialize() {
    this.setModule('glive_booking_redesign');
    this.presenter = DatePickerPresenter;
    this.templateName = 'datepicker';
  }

  className() {
    return 'picker glive-picker collapsed dates';
  }

  content() {
    if (this.shouldDisplayCalendar()) {
      if (!this._calendarContent) {
        this._calendarContent = new CalendarView({
          collection: this.collection,
          selected: this.selected(),
        });

        this._calendarContent.on('select', this.select, this);
        this._calendarContent.render();
      }

      this.$el.addClass('calendar-view');

      return this._calendarContent;
    } else {
      if (!this._listContent) {
        this._listContent = new DatesView({
          collection: this.collection,
          selected: this.selected(),
        });

        this._listContent.on('select', this.select, this);
        this._listContent.render();
      }

      this.$el.removeClass('calendar-view');

      return this._listContent;
    }
  }

  shouldDisplayCalendar() {
    return (
      this.collection.size() > Constants.date.calendarMinThreshold && this.collection.models.every(this.isValidDateTime)
    );
  }

  isValidDateTime(model) {
    return model.get('type') === 'datetime';
  }

  show() {
    const clearMaxHeight = this.shouldDisplayCalendar();
    super.show(Constants.picker.listMaxThreshold, clearMaxHeight);
  }
}

module.exports = DatePickerView;
